"use strict";

var _ = require("underscore");
var cx = require("classnames");
var Reflux = require("reflux");
var moment = require("moment");
var DatetimePicker = require("./datetime-picker.jsx");
var UserSelectBox = require("./user-select-box.jsx");
var UserSelectBoxStore = require("app/screens/Activity/stores/user-select-box-store");

var ScheduleStore = require("app/screens/Activity/stores/schedule-store");
var ScheduleActions = require("app/screens/Activity/actions/schedule-actions");

var MultiActionStore = require("app/util/flux/multi-action-store");

var Schedule = React.createClass({
  mixins: [Reflux.ListenerMixin, MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      userSelectBoxStore: UserSelectBoxStore,
      scheduleStore: ScheduleStore,
      scheduleActions: ScheduleActions
    };
  },
  getInitialState: function(){
    var initialState = this.scheduleStore.state;
    return initialState;
  },
  componentDidMount: function(){
    this.listenTo(this.scheduleStore, this.setState);
    this.listenTo(this.userSelectBoxStore, this.handleUserSelectBoxStateChange);
    $(document).on("click", this.handleMouseClick);
  },
  componentWillUnmount: function(){
    $(document).off("click", this.handleMouseClick);
  },
  handleMouseClick: function(e){
    var isHover = $(this.refs.wrapper).is(":hover");
    if( this.state.open && !isHover ){
      this.scheduleActions.toggle(false);
    }
  },
  handleUserSelectBoxStateChange: function(state){
    var selectedUsers = _.filter(state.users, function(user){
      return user.checked;
    });
    this.scheduleActions.setSelectedUsers(selectedUsers);
  },
  handleDatetimePickerStateChange: function(state){
    this.scheduleActions.setDatetime(state);
  },
  defineSchedule: function(){
    this.scheduleActions.define(this.state.date, this.state.time, this.state.selectedUsers);
  },
  render: function render(){

    var wrapperClasses = cx(
      "activityInput-schedule",
      { "d-n": !this.state.open }
    );

    var styles = {
      left: this.state.posX + "px",
      top: this.state.posY + "px"
    };

    var datetimePickerProps = {
      dueDate: this.state.date+" "+this.state.time,
      stateChangeListener: this.handleDatetimePickerStateChange,
      closeAfterSetValidDatetime: false
    };

    return (
      <div className={wrapperClasses} style={styles} ref="wrapper">
        <DatetimePicker {...datetimePickerProps} />
        <UserSelectBox instanceKey={this.props.instanceKey} selectedUsers={this.state.selectedUsers} classes="pb-50" />
        <button disabled={this.state.disableDefineButton} onClick={this.defineSchedule} className="btn r-10 b-10 p-a fs-12 w-220 ta-c btn-primary fw-600 tt-upper">Definir</button>
      </div>
    );
  }
});

module.exports = Schedule;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/schedule.jsx